<template>
  <!--超时-->
  <div class="table-page-search-wrapper">
    <a-form :form="form" layout="inline">
      <a-row :gutter="6">
        <a-col :span="6">
          <a-form-item label="订单号" style="margin-left: 13px">
            <a-input v-decorator="['orderNo', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="客户姓名">
            <a-input v-decorator="['clientName', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="客户联系方式">
            <a-input v-decorator="['clientPhone', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="超时类型">
            <a-select v-decorator="['matterCode', { rules: [{ required: false, message: '选择' }] }]">
              <a-select-option :title="type.name" v-for="type in resTypes" :key="type.code">{{
                type.name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <!--      <a-row :gutter="6">-->
      <!--        <a-col :span="6">-->
      <!--          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理时长">-->
      <!--            <a-row>-->
      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime1"  @keyup.native="number1"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="2">-->
      <!--                <span>至</span>-->
      <!--              </a-col>-->

      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime2" @keyup.native="number2"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="10">-->
      <!--                <a-select v-model="querytime.selectTime1"   @change="timeChange1">-->
      <!--                  <a-select-option title="选择" value=""> 选择 </a-select-option>-->
      <!--                  <a-select-option title="天" value="d"> 天 </a-select-option>-->
      <!--                  <a-select-option title="小时" value="h"> 小时 </a-select-option>-->
      <!--                </a-select>-->
      <!--              </a-col>-->
      <!--            </a-row>-->
      <!--          </a-form-item>-->
      <!--        </a-col>-->
      <!--        <a-col :span="6">-->
      <!--          <a-form-item label="处理情况">-->
      <!--            <a-select v-decorator="['handlingStatus', { rules: [{ required: false, message: '选择' }] }]" >-->
      <!--                <a-select-option title="待处理" value="0">-->
      <!--                  待处理-->
      <!--                </a-select-option>-->
      <!--              <a-select-option title="处理完成" value="1">-->
      <!--                  处理完成-->
      <!--              </a-select-option>-->
      <!--              </a-select>-->
      <!--          </a-form-item>-->
      <!--        </a-col>-->
      <!--        <a-col :span="6">-->
      <!--          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总处理时长" style="margin-left: 13px;">-->
      <!--            <a-row>-->
      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime3"  @keyup.native="number3"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="2">-->
      <!--                <span>至</span>-->
      <!--              </a-col>-->

      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime4" @keyup.native="number4"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="10">-->
      <!--                <a-select v-model="querytime.selectTime2"   @change="timeChange2">-->
      <!--                  <a-select-option title="选择" value=""> 选择 </a-select-option>-->
      <!--                  <a-select-option title="天" value="d"> 天 </a-select-option>-->
      <!--                  <a-select-option title="小时" value="h"> 小时 </a-select-option>-->
      <!--                </a-select>-->
      <!--              </a-col>-->
      <!--            </a-row>-->
      <!--          </a-form-item>-->
      <!--        </a-col>-->
      <!--      </a-row>-->
      <a-row :gutter="6" style="margin: 20px 0 50px 0">
        <a-col :span="16">
          <!--          <a-radio-group name="radioGroup" v-model="isMyCreate" >-->
          <!--            <a-radio :value="'0'">-->
          <!--              我的待办-->
          <!--            </a-radio>-->
          <!--            <a-radio :value="'1'">-->
          <!--              我的发起-->
          <!--            </a-radio>-->
          <!--          </a-radio-group>-->
        </a-col>
        <a-col :span="4" :offset="3">
          <span style="display: flex; justify-content: center">
            <a-button class="twobtn" style="margin-left: 20px" v-if="exportEnable" type="primary" @click="exporto()"
              >导出</a-button
            >
            <a-button class="twobtn" style="margin-left: 35px" htmlType="submit" type="primary" @click="query()"
              >查询</a-button
            >
            <a-button class="twobtn" style="margin-left: 35px" @click="restdata()">清空</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      size="default"
      ref="table"
      rowKey="modelId"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :data-source="complaintData"
      :scroll="{ x: 300 }"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a v-if="record.statusCode == 0" @click="handles(record)">处理 <a-divider type="vertical" /></a>

        <a v-if="record.statusCode == 0 && dispatchEnable" @click="Transfer(record)"
          >转派<a-divider type="vertical"
        /></a>

        <a-popover trigger="click" title="履历">
          <template slot="content">
            <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
              <div v-for="item in dataResume">
                <p>履历内容:{{ item.content }}</p>
                <p>操作人姓名:{{ item.createName }}</p>
                <p>操作时间:{{ item.createTime }}</p>
                <a-divider type="vertical" />
              </div>
            </div>
          </template>
          <a @click="Resume(record)" v-if="recodeEnable"> 履历 </a>
        </a-popover>

        <a @click="withdraw(record)"><a-divider type="vertical" />完成</a>
      </span>
    </a-table>
    <!--分页-->
    <a-pagination
      show-size-changer
      show-quick-jumper
      :default-current="1"
      :total="total"
      @change="onChangePage"
      @showSizeChange="onShowSizeChange"
      style="float: right; margin: 30px 10px 10px 0"
    />
    <!--转派弹框-->
    <a-modal
      title="转派"
      :width="800"
      v-model="visible2"
      :confirmLoading="confirmLoading2"
      @ok="handleSubmit2"
      :closable="false"
      :maskClosable="false"
    >
      <a-form :form="form2" layout="inline">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="转派角色">
              <a-select
                v-decorator="['roleCode', { rules: [{ required: false, message: '选择' }] }]"
                style="width: 300px"
              >
                <a-select-option v-for="type in Roledata" :key="type.code">{{ type.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--完成弹框-->
    <a-modal
      title="完成"
      :width="800"
      v-model="visible3"
      :confirmLoading="confirmLoading3"
      @ok="handleSubmit3"
      :closable="false"
      :maskClosable="false"
    >
      <a-form>
        <a-row :gutter="24">
          <a-col :span="2">
            <a-form-item label="处理完成"></a-form-item>
          </a-col>
          <a-col :span="20">
            <a-textarea style="margin-top: 10px" v-model="processResult" :auto-size="{ minRows: 3, maxRows: 5 }" />
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
    <edit-order-model1 v-else ref="editorder"></edit-order-model1>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'Toexamine',
  components: {
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
  },
  data() {
    return {
      batchEnable: checkPermission('toDo:batch'), //批量处理
      exportEnable: checkPermission('toDo:export'), //导出
      dispatchEnable: checkPermission('toDo:dispatch'), //转派
      recodeEnable: checkPermission('toDo:recode'), //履历
      form: this.$form.createForm(this),
      queryParam: {},
      visible: false,
      confirmLoading: false,
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          width: '70px',
          align: 'center',
        },
        {
          title: '操作',
          width: '20px',
          dataIndex: 'statusArea',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '处理情况',
          dataIndex: 'handlingStatus',
          align: 'center',
        },
        {
          title: '超时类型',
          dataIndex: 'matterName',
          align: 'center',
        },
        {
          title: '超时时长',
          dataIndex: 'timeoutLength',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installTypeName',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '客户电话',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipalName',
          align: 'center',
        },
        // {
        //   title: '当前协助人',
        //   dataIndex: 'helperName',
        //   align:'center'
        // },
        // {
        //   title: '当前处理人姓名',
        //   dataIndex: 'currentHandlerName',
        //   align:'center'
        // },
        // {
        //   title: '发起时间',
        //   dataIndex: 'createTime',
        //   align:'center'
        // },
        // {
        //   title: '处理完成时间',
        //   dataIndex: 'handleEndTime',
        //   align:'center'
        // },
        // {
        //   title: '总处理时长',
        //   dataIndex: 'totalProcessingTimeInfo',
        //   align:'center'
        // },
      ],
      pagination: false,
      loading: false,
      complaintData: [],
      querytime: {},
      isMyOrder: false,
      resTypes: [],
      isMyCreate: '0',
      visible2: false,
      confirmLoading2: false,
      form2: this.$form.createForm(this),
      Roledata: [],
      timeoutId: '',
      visible3: false,
      confirmLoading3: false,
      processResult: '',
      orderId: '',
      total: 0,
      pageSize: 10,
      pageNum: 1,
      dataResume: [],
    }
  },
  methods: {
    //查询参数
    Biography(values) {
      values.isMyCreate = this.isMyCreate
      values.pageSize = this.pageSize
      values.pageNum = this.pageNum
      //处理时长
      values.timeoutLengthStart = this.querytime.textTime1
      values.timeoutLengthEnd = this.querytime.textTime2
      values.timeoutLengthType = this.querytime.selectTime1
      values.totalProcessingTimeStart = this.querytime.textTime3
      values.totalProcessingTimeEnd = this.querytime.textTime4
      values.totalProcessingTimeType = this.querytime.selectTime2
      return values
    },
    //导出
    exporto() {
      this.form.validateFields((err, values) => {
        var str = process.env.VUE_APP_API_BASE_URL + '/backlog/timeout/export?pageSize=10&pageNum=1'

        var arrStr = this.Biography(values)
        for (let i in arrStr) {
          if (arrStr[i] != undefined) {
            str = str + '&' + i + '=' + arrStr[i]
          }
        }
        str = str + '&token=' + this.headers.token
        window.open(str)

        // this.$axios({
        //   method: "get",
        //   url: "/api/backlog/timeout/export",
        //   params:this.Biography(values),
        //   responseType: 'arraybuffer',
        //   headers: {
        //     token: Vue.ls.get(ACCESS_TOKEN),
        //     'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //   }
        // }).then((res) => {
        //   const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = '超时'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   window.URL.revokeObjectURL(href)
        // })
      })
    },
    //处理
    handles(value) {
      if (value.jumpUrl === 'orderInfo') {
        //订单详情
        // this.$router.push({path:'/order/orderList', query:{orderNo: value.orderNo}})
        // this.$emit('Ok')
        this.$refs.editorder.showeditOrder(value.orderId, 1, 1)
      }
    },
    //履历
    Resume(values) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersResume',
        params: {
          pendingMattersRecordId: values.timeoutId,
          matterCode: values.matterCode,
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res)
        this.dataResume = res.data.data
      })
      // /pendingMatter/getPendingMattersResume
    },
    //分页
    onChangePage(pageNumber) {
      this.pageNum = pageNumber
      this.query()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.pageNum = current
      this.query()
    },
    //完成
    withdraw(value) {
      this.processResult = ''
      this.visible3 = true
      this.timeoutId = value.timeoutId
      this.orderId = value.orderId
    },
    //处理完成提交
    handleSubmit3() {
      this.$axios({
        method: 'post',
        url: '/api/backlog/timeout/end',
        data: {
          timeoutId: this.timeoutId,
          processResult: this.processResult,
          orderId: this.orderId,
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('处理完成')
          this.visible3 = false
          this.query()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //转派提交
    handleSubmit2() {
      this.form2.validateFields((err, values) => {
        this.$axios({
          method: 'post',
          url: '/api/backlog/timeout/transfer',
          params: {
            timeoutId: this.timeoutId,
            roleCode: values.roleCode,
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('转派成功')
            this.visible2 = false
            this.query()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    //转派
    Transfer(value) {
      this.timeoutId = value.timeoutId
      this.visible2 = true
      //获取转派角色列表
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersRoleList',
        params: {
          type: '',
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.Roledata = res.data.data
      })
    },
    //时间区间
    timeChange1(value) {
      this.querytime.selectTime1 = value
    },
    timeChange2(value) {
      this.querytime.selectTime2 = value
    },
    number1() {
      this.regular(this.querytime.textTime1)
    },
    number2() {
      this.regular(this.querytime.textTime2)
    },
    number3() {
      this.regular(this.querytime.textTime3)
    },
    number4() {
      this.regular(this.querytime.textTime4)
    },
    regular(value) {
      value = value.replace(/[^\.\d]/g, '')
      value = value.replace('.', '')
    },
    restdata() {
      this.isMyCreate = '0'
      this.form.resetFields()
      this.querytime = {}
      this.query()
    },
    // 刷新表格数据
    dataList(data) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/timeout/getTimeoutList',
        params: data,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.complaintData = res.data.rows
        this.total = res.data.total
        this.$emit('Ok')
      })
    },
    //查询
    query() {
      this.form.validateFields((err, values) => {
        if (this.isMyCreate == 1) {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center',
            },
            {
              title: '处理情况',
              dataIndex: 'handlingStatus',
              align: 'center',
            },
            {
              title: '超时类型',
              dataIndex: 'matterName',
              align: 'center',
            },
            {
              title: '超时时长',
              dataIndex: 'timeoutLength',
              align: 'center',
            },
            {
              title: '企业名称',
              dataIndex: 'enterpriseName',
              align: 'center',
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipal',
              align: 'center',
            },
            {
              title: '订单号',
              dataIndex: 'orderNo',
              align: 'center',
            },
            {
              title: '安装类别',
              dataIndex: 'installTypeName',
              align: 'center',
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center',
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center',
            },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center',
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center',
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center',
            },
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            // {
            //   title: '当前处理人姓名',
            //   dataIndex: 'currentHandlerName',
            //   align:'center'
            // },
            // {
            //   title: '发起时间',
            //   dataIndex: 'createTime',
            //   align:'center'
            // },
            // {
            //   title: '处理完成时间',
            //   dataIndex: 'handleEndTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // },
          ]
        } else {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center',
            },
            {
              title: '操作',
              width: '20px',
              dataIndex: 'statusArea',
              scopedSlots: { customRender: 'action' },
            },
            {
              title: '处理情况',
              dataIndex: 'handlingStatus',
              align: 'center',
            },
            {
              title: '超时类型',
              dataIndex: 'matterName',
              align: 'center',
            },
            {
              title: '超时时长',
              dataIndex: 'timeoutLength',
              align: 'center',
            },
            {
              title: '企业名称',
              dataIndex: 'enterpriseName',
              align: 'center',
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipal',
              align: 'center',
            },
            {
              title: '订单号',
              dataIndex: 'orderNo',
              align: 'center',
            },
            {
              title: '安装类别',
              dataIndex: 'installTypeName',
              align: 'center',
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center',
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center',
            },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center',
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center',
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center',
            },
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            // {
            //   title: '当前处理人姓名',
            //   dataIndex: 'currentHandlerName',
            //   align:'center'
            // },
            // {
            //   title: '发起时间',
            //   dataIndex: 'createTime',
            //   align:'center'
            // },
            // {
            //   title: '处理完成时间',
            //   dataIndex: 'handleEndTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // },
          ]
        }
        this.dataList(this.Biography(values))
      })
    },
  },
  created() {
    //获取超时类型下拉框
    this.$axios({
      method: 'get',
      url: '/api/backlog/pendingMatter/getPendingMatterMenu',
      params: {
        matterTypeCode: 'timeout',
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8',
      },
    }).then((res) => {
      this.resTypes = res.data.data
      console.log(res.data.data, '获取投诉类型下拉框')
    })
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>